"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromGQL = exports.toGQL = exports.CUSTOMER_PROVIDED_VALUES = exports.CustomerProvidedLoanTapeMetadataArraySchema = exports.CustomerProvidedLoanTapeMetadataSchema = exports.CustomerProvidedMetadataValueSchema = void 0;
const zod_1 = require("zod");
exports.CustomerProvidedMetadataValueSchema = zod_1.z.union([
    zod_1.z.number(),
    zod_1.z.string(),
    zod_1.z.boolean(),
    zod_1.z.null(),
]);
exports.CustomerProvidedLoanTapeMetadataSchema = zod_1.z.object({
    // this is "formula engine variable" (less loanTapeMetadata prefix)
    key: zod_1.z.string(),
    value: exports.CustomerProvidedMetadataValueSchema,
});
exports.CustomerProvidedLoanTapeMetadataArraySchema = zod_1.z.array(exports.CustomerProvidedLoanTapeMetadataSchema);
exports.CUSTOMER_PROVIDED_VALUES = 'customerProvidedValues';
const toGQL = (input) => {
    if (!input)
        return [];
    return Object.entries(input).map(([key, value]) => ({
        key,
        value: value ?? null,
    }));
};
exports.toGQL = toGQL;
const fromGQL = (input) => {
    const result = {};
    for (const item of input) {
        result[item.key] = item.value;
    }
    return result;
};
exports.fromGQL = fromGQL;
``;
//# sourceMappingURL=CustomerProvideValues.js.map